import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { motion } from 'framer-motion';
import styles from './styles.module.scss';

const Blockquote = ({
  text = '',
  author = '',
  theme = '',
  align = 'center',
  blockId = null,
  contentWidth = 70,
}) => {
  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
  };

  const lineVariants = {
    hidden: { width: 0 },
    visible: { width: 70, transition: { duration: 0.3, ease: 'easeOut', delay: 0.2 } },
  };

  return (
    <section
      id={blockId}
      className={cn(styles.blockquote, {
        [styles.themeLight]: theme === 'light',
        [styles.themeDark]: theme === 'dark',
        [styles.themeNone]: theme === 'none',
      })}
    >
      <div className={styles.inner}>
        <div className="container">
          <motion.div
            className={cn(styles.contentWrapper, {
              [styles.alignLeft]: align === 'left',
              [styles.alignCenter]: align === 'center',
              [styles.alignRight]: align === 'right',
            })}
            initial="hidden"
            whileInView="visible"
            viewport={{ margin: '-100px' }}
            variants={containerVariants}
            style={{ maxWidth: `${contentWidth}%` }}
          >
            <motion.span className={styles.divider} variants={lineVariants} />
            <div className={styles.content} dangerouslySetInnerHTML={{ __html: text }} />
            <motion.span className={styles.divider} variants={lineVariants} />
            {author && <div className={styles.author}>{author}</div>}
          </motion.div>
        </div>
      </div>
    </section>
  );
};


Blockquote.propTypes = {
  text: PropTypes.string,
  author: PropTypes.string,
  theme: PropTypes.oneOf(['light', 'dark', 'none']),
  align: PropTypes.oneOf(['left', 'center', 'right']),
  blockId: PropTypes.string,
  contentWidth: PropTypes.number,
};

export default Blockquote;
